module.exports = __webpack_public_path__ + "static/media/Ary de Farias_E Foi Assim_front cover.a8348fa0.jpg";